import React from 'react';
import styles from './style/Button.module.scss';
import '../../styles/palette.scss'

export const Button = (props: ButtonProps) => {
  const {
    buttonStyle = 'primary',
    label,
    type = 'button',
    ...rest
  } = props;

  return (
    <button
      {...rest}
      className={`${styles.button} ${styles[buttonStyle]}`}
      type={type}
    >
      {label}
    </button>
  )
};

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Applies button styles
   * @default primary
   */
  buttonStyle?: 'primary' | 'secondary';
  /**
   * Text to show on the button
   */
  label?: string | React.ReactNode;
}
